import { render, staticRenderFns } from "./CustomerUsageBarChart.vue?vue&type=template&id=387b5a48&"
import script from "./CustomerUsageBarChart.vue?vue&type=script&lang=ts&"
export * from "./CustomerUsageBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports